module.exports = __webpack_public_path__ + "static/img/report-buttom.92357c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/report-buttom.png
// module id = R+Qk
// module chunks = 1